<template>
  <div class="wait_container" :style="{height: clientHeight+'px'}">
      <div class="wait_text">敬请期待~</div>
  </div>

</template>
<script>
export default {
  data() {
    return {};
  },
  components: {},
  mounted() {},
  methods: {},
  computed: {
    clientHeight() {
      return document.body.clientHeight;
    }
  }
};
</script>
<style lang="scss" scoped>
.wait_container {
  background: white;
  position:relative;
  .wait_text{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      color: #787878;
      font-size: 16px;
      letter-spacing: 0.5px;
  }
}
</style>
